import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WWPitaBreadProduct from 'models/WWPitaBreadProduct'
import WWPitaBreadPackage from './WWPitaBreadPackage'

const productOptions = {
  packagingInfo: <WWPitaBreadPackage />,
  productTitle: 'Whole Wheat Pita Bread',
  model: WWPitaBreadProduct,
  validCategories: ['16'],
  validSubCategories: ['012'],
}

const WWPitaBread = () => <ProductForm product={productOptions} />

export default WWPitaBread
